export default __webpack_public_path__ + "static/media/GBLB_Logo_Horizontal_Notag_White_FullColor.2df3f4b6.png";